import { EntityListAccessor, useGetEntitySubTree } from '@contember/admin'

export const useGetCurrentEdition = (editions: EntityListAccessor) => {
	const lastEdition = Array.from(editions)[0]
	return lastEdition
}
